import { DBDocObject } from '../../../legacy/objects/generic/db-doc/db-doc-object';
import { SessionURL } from '../../core/session-url/session-url';
import { DomMutationSelection } from '../dom-mutation-selection/dom-mutation-selection';
import { ExperienceTrigger } from '../experience-trigger/experience-trigger';

import { DomExperienceConstructor } from './dom-experience-constructor';
import { DomExperienceSchema } from './dom-experience-schema';
import { DomExperienceType } from './dom-experience-type';
import { SearchExperienceConfig } from './experiments/search-experience-config/search-experience-config';

export class DomExperience extends DBDocObject {
  /////////////////////////////////////////////////////////////////////////////
  // Variables
  /////////////////////////////////////////////////////////////////////////////

  protected displayName: string | undefined;
  protected description: string | undefined;
  protected type!: DomExperienceType;
  protected trigger!: ExperienceTrigger;
  protected mutations!: DomMutationSelection[];
  protected searchExperienceConfig!: SearchExperienceConfig | undefined;
  protected enabled?: boolean;
  protected canApply?: boolean;

  /////////////////////////////////////////////////////////////////////////////
  // Get Schema
  /////////////////////////////////////////////////////////////////////////////

  public static getSchema(): DomExperienceSchema {
    return new DomExperienceSchema();
  }

  /////////////////////////////////////////////////////////////////////////////
  // Constructor
  /////////////////////////////////////////////////////////////////////////////

  constructor(input: DomExperienceConstructor) {
    super(input);
  }

  /////////////////////////////////////////////////////////////////////////////
  // Serialize
  /////////////////////////////////////////////////////////////////////////////

  public serialize() {
    return super.serialize(DomExperience.getSchema());
  }

  /////////////////////////////////////////////////////////////////////////////
  // Deserialize
  /////////////////////////////////////////////////////////////////////////////

  protected static _deserialize(validationResult: import('joi').ValidationResult): DomExperience {
    return new DomExperience(super._deserialize(validationResult));
  }

  /////////////////////////////////////////////////////////////////////////////
  // Getters
  /////////////////////////////////////////////////////////////////////////////

  public getDisplayName() {
    return this.displayName;
  }

  public getDescription() {
    return this.description;
  }

  public getType() {
    return this.type;
  }

  public getTrigger() {
    return this.trigger;
  }

  public getMutations() {
    return this.mutations;
  }

  public getSearchExperienceConfig() {
    return this.searchExperienceConfig;
  }

  public getEnabled() {
    return this.enabled ?? true;
  }

  public getCanApply() {
    return this.canApply ?? true;
  }

  /////////////////////////////////////////////////////////////////////////////
  // Methods
  /////////////////////////////////////////////////////////////////////////////

  public getMatchingMutation = (triggerURL: SessionURL): string | undefined => {
    for (const mutation of this.mutations ?? []) {
      if (mutation.getUrl().getPathname() === triggerURL.getPathname()) {
        return mutation.getDomMutationId();
      }
    }

    return undefined;
  };
}
